import type { AccordionProps } from '@/components/landing-page/components/accordion';

export const defaults: Required<AccordionProps> = {
  title: '',
  blocks: [],
  duration: 0.1,
};
